import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import "../../Component/Navbar/navbar.css";
import "./home.css";

import Navbar from "../../Component/Navbar/Navbar";
import FAQ from "../../Component/FAQ/FAQ";
import Testimonial from "../../Component/Testimonial/Testimonial";
import Footer from "../../Component/Footer/Footer";
import Register from "../Register/Register";
import Icon from "@mdi/react";
import { mdiPhone, mdiEmail, mdiMapMarker } from "@mdi/js";

export default function Home() {
  const { t } = useTranslation();
  const setShowLogin = useState(false);
  const [showRegister, setShowRegister] = useState(false);

  // Restore scroll in case it was locked by internal pages (Dashboard, Sidebar, Modal)
  useEffect(() => {
    document.body.style.overflow = "auto";
    document.body.classList.remove("lock-scroll");

    return () => {
      document.body.style.overflow = "auto";
      document.body.classList.remove("lock-scroll");
    };
  }, []);

  // ✅ EmailJS Integration
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_noejnaw",
        "template_jeuexhd",
        e.target,
        "GS6BipHHaEzyqwDeM"
      )
      .then(
        () => {
          Swal.fire({
            icon: "success",
            title: "Pesan Terkirim!",
            text: "Terima kasih telah menghubungi kami. Kami akan segera merespons 😊",
            showConfirmButton: false,
            timer: 2500,
            customClass: {
              popup: 'rounded-lg',
            }
          });
          e.target.reset();
        },
        (error) => {
          console.error(error.text);
          Swal.fire({
            icon: "error",
            title: "Gagal Mengirim Pesan!",
            text: "Silakan coba lagi nanti.",
            confirmButtonColor: "#3085d6",
          });
        }
      );
  };

  const sectionStyle = {
    background: `linear-gradient(rgba(255, 153, 0, 0.8), rgba(255, 102, 0, 0.85)), url("/Images/layanan.png") center/cover no-repeat`,
    color: "#fff",
  };

  return (
    <div className="home-container">
      <Navbar />

      {/* HERO SECTION */}
      <section id="beranda" className="hero-section responsive-hero">
        <div className="hero-text">
          <h1 className="roll-text" dangerouslySetInnerHTML={{ __html: t("home.hero_title") }}></h1>
          <p>
            {t("home.hero_subtitle")}
          </p>
          <div className="hero-buttons">
            <button
              className="btn-primary"
              onClick={() => {
                setShowRegister(true);
                setShowLogin(false);
              }}
            >
              {t("home.btn_register")}
            </button>
          </div>
          <Register show={showRegister} onClose={() => setShowRegister(false)} />
        </div>

        {/* HERO IMAGE WITH FLOATING COINS */}
        <div className="hero-image-container">
          <img src="/Images/content.png" alt="Home" className="hero-image" />

          {/* Gold Coins */}
          <img src="/Images/coin.png" alt="coin" className="coin gold top-right" />
          <img src="/Images/coin.png" alt="coin" className="coin gold bottom-right" />
          <img src="/Images/coin.png" alt="coin" className="coin gold bottom-left" />

          {/* Silver Coins */}
          <img src="/Images/coin2.png" alt="coin" className="coin silver mid-left" />
          <img src="/Images/coin2.png" alt="coin" className="coin silver top-left" />
          <img src="/Images/coin2.png" alt="coin" className="coin silver bottom-right-small" />
        </div>


      </section>



      {/* INFO SECTION */}
      <section className="info-section">
        <div className="info-content">
          <img src="/Images/ramah.png" alt="Info" />
          <p dangerouslySetInnerHTML={{ __html: t("home.info_text") }}></p>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section id="layanan" className="services" style={sectionStyle}>
        <div className="overlay">
          <h2 className="services-title">{t("home.services_title")}</h2>
          <p className="services-desc">
            {t("home.services_desc")}
          </p>

          <div className="service-cards">
            <div className="service-card">
              <img
                src="https://cdn-icons-png.flaticon.com/512/10373/10373828.png"
                alt="Asisten Anggaran"
              />
              <h3>{t("home.service1_title")}</h3>
              <p>
                {t("home.service1_desc")}
              </p>
            </div>

            <div className="service-card">
              <img
                src="https://cdn-icons-png.flaticon.com/512/8943/8943377.png"
                alt="Chatbot AI"
              />
              <h3>{t("home.service2_title")}</h3>
              <p>
                {t("home.service2_desc")}
              </p>
            </div>

            <div className="service-card">
              <img
                src="https://cdn-icons-png.flaticon.com/512/18479/18479071.png"
                alt="Pelacakan Pengeluaran Pintar"
              />
              <h3>{t("home.service3_title")}</h3>
              <p>
                {t("home.service3_desc")}
              </p>
            </div>

            <div className="service-card">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2065/2065325.png"
                alt="Sistem Menabung dengan Gamifikasi"
              />
              <h3>{t("home.service4_title")}</h3>
              <p>
                {t("home.service4_desc")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <FAQ />

      {/* CONTACT SECTION */}
      <section id="kontak" className="contact-section">
        <h2 className="contact-title">{t("home.contact_title")}</h2>
        <p className="contact-desc">
          {t("home.contact_desc")}
        </p>

        <div className="contact-container">
          {/* LEFT SIDE */}
          <div
            className="contact-info"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL + '/Images/home.png'})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="info-overlay">
              <h2>{t("home.contact_title")}</h2>
              <p>
                {t("home.contact_desc")}
              </p>
              <ul className="contact-details">
                <li>
                  <Icon path={mdiPhone} size={1} color="white" /> +62 856-9110-7975
                </li>
                <li>
                  <Icon path={mdiEmail} size={1} color="white" /> lacakas.kascash@gmail.com
                </li>
                <li>
                  <Icon path={mdiMapMarker} size={1} color="white" /> Bekasi, Indonesia
                </li>
              </ul>
            </div>
          </div>

          {/* RIGHT SIDE: FORM */}
          <form className="contact-form" onSubmit={sendEmail}>
            <div className="form-row">
              <div className="form-group">
                <label>{t("home.contact_name")}</label>
                <input type="text" name="user_name" placeholder={t("home.contact_name")} required />
              </div>
              <div className="form-group">
                <label>{t("home.contact_phone")}</label>
                <input type="text" name="user_phone" placeholder={t("home.contact_phone")} required />
              </div>
            </div>

            <div className="form-group">
              <label>{t("home.contact_email")}</label>
              <input type="email" name="user_email" placeholder={t("home.contact_email")} required />
            </div>

            <div className="form-group">
              <label>{t("home.contact_message")}</label>
              <textarea name="message" placeholder={t("home.placeholder_message")} rows="4" required></textarea>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-cancel">{t("home.btn_cancel")}</button>
              <button type="submit" className="btn-submit">{t("home.btn_submit")}</button>
            </div>
          </form>
        </div>
      </section>

      <Testimonial />
      <Footer />
    </div>
  );
}